export const STANDARD_INVENTORY = 'STANDARD_INVENTORY'
export const LIMITED_INVENTORY = 'LIMITED_INVENTORY'
export const NO_BRAND_SAFETY = 'NO_BRAND_SAFETY'

export const brandSafetyOptions = [
  {
    value: NO_BRAND_SAFETY,
    label: 'No Brand Safety'
  },
  {
    value: STANDARD_INVENTORY,
    label: 'Standard Inventory'
  },
  {
    value: 'EXPANDED_INVENTORY',
    label: 'Expanded Inventory'
  },
  {
    value: 'THIRD_PARTY',
    label: 'Third Party'
  },
  {
    value: LIMITED_INVENTORY,
    label: 'Limited Inventory'
  }
]
